import { render } from "./PropertyTemplate.vue?vue&type=template&id=1b42c78a&scoped=true"
import script from "./PropertyTemplate.vue?vue&type=script&lang=js"
export * from "./PropertyTemplate.vue?vue&type=script&lang=js"

import "./PropertyTemplate.vue?vue&type=style&index=0&id=1b42c78a&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b42c78a"]])

export default __exports__